import { render } from "./ChoosePower.vue?vue&type=template&id=35df8298&scoped=true&ts=true"
import script from "./ChoosePower.vue?vue&type=script&lang=ts"
export * from "./ChoosePower.vue?vue&type=script&lang=ts"

import "./ChoosePower.vue?vue&type=style&index=0&id=35df8298&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35df8298"]])

export default __exports__